import React, { useState } from "react";
import { Row, Col, Divider,Button } from "antd";
import {
  BsFileEarmarkWord,
  BsCalendarMinus,
  AiOutlineClockCircle,
} from "react-icons/all";
import moment from "moment";
import CustomModal from "../modals/customModal";
import Delete_order from "../../assets/images/delete_order.png";

const FileView = ({ item, deleteDocReq, orderId, isTesting }) => {
  const [isOpenModal, setOpenModal] = useState(false);
  return (
    <>
      <Col span={24}>
        <Row>
          <Col span={2}>
            <BsFileEarmarkWord size={"30"} color="blue" />
          </Col>
          <Col span={20}>
            <h2>{item?.attachment_file_name}</h2>
          </Col>
        </Row>
        <Row justify="space-between">
          <Col span={2}></Col>
          <Col span={1}>
            <img
              src={item?.uploaded_by_user_image?.original}
              height="30"
              width={"30"}
            />
          </Col>
          <Col span={8}>
            <Row>
              <Col span={24}>
                <span>Uploaded by: {item?.uploaded_by}</span>
              </Col>
              <Col span={24}>
                <span
                  style={{ borderRadius: "5px", padding: "3px" }}
                  className={"grey order-status-label"}
                >
                  {item?.uploaded_by_user_type}
                </span>{" "}
              </Col>
            </Row>
          </Col>
          <Col span={6}>
            <Row>
              <Col span={4}>
                <BsCalendarMinus size={"25"} />
              </Col>
              <Col span={20}>
                <p> {moment(item?.created_at).format("LL")}</p>
              </Col>
            </Row>
          </Col>
          <Col span={3}>
            <Row>
              <Col span={8}>
                <AiOutlineClockCircle size={"25"} />
              </Col>
              <Col span={16}>
                <p> {moment(item?.created_at).format("LT")}</p>
              </Col>
            </Row>
          </Col>
          <Col span={4}>
            <Row justify="space-between">
              <Col
                span={13}
                className="st-primary pointer-cursor"
                onClick={() => (window.location.href = item?.attachment)}
              >
                Download
              </Col>
              <Col span={10} onClick={() => setOpenModal(true)}>
                <p className="danger-color pointer-cursor">Delete</p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      <CustomModal
        visible={isOpenModal}
        onCancelModal={() => setOpenModal(false)}
        footer={[
          <Row justify="center" style={{ margin: "20px" }}>
            <Col
              className="d-flex justify-content-center"
              style={{ width: "100%" }}
            >
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() =>
                  deleteDocReq(orderId, item.id, {
                    params: isTesting ? "test_documents" : "documents",
                  })
                }
              >
                YES
              </Button>
              <Button
                style={{
                  backgroundColor: "#26a69a ",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() => setOpenModal(false)}
              >
                NO
              </Button>
            </Col>
          </Row>,
        ]}
      >
        <Row justify="center">
          <Col className="d-flex justify-content-center" span={24}>
            <img src={Delete_order} />
          </Col>
          <Col span={12} style={{ textAlign: "center" }}>
            <span>{"Are you sure you want to delete this file?"}</span>
          </Col>
        </Row>
      </CustomModal>
      <Col span={24} style={{ marginTop: "1rem" }}>
        <Divider />
      </Col>
    </>
  );
};
export default FileView;
